import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterIds,
  handleChangeSortBy,
  handleToggleCollapsed,
  handleSetSelectedFilterValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './resourceHelpers';
import { newsFiltersInitialState } from './initialState/newsInitialState';

export { newsFiltersInitialState as filtersInitialState };

export const newsSearchResourceInitialState = {
  filters: newsFiltersInitialState,
  // sortBy: {
  //   selected: '',
  //   order: 'desc',
  // },
  selectedFilter: 'languageFilter',
};
export const newsSearchResourceSlice = createSlice({
  name: 'newsSearchResourceSlice',
  initialState: newsSearchResourceInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, newsFiltersInitialState);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = newsFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, newsFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedFilterValue,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = newsSearchResourceSlice.actions;
